"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var ZoomRoomChair = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_ZoomRoomChair_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 .5H4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2Zm-5.784 7c.314-.449.882-.856 1.783-.856.902 0 1.471.407 1.785.856H6.216Zm8.296 3.83.888 3.549a.5.5 0 1 1-.97.242l-.906-3.621H11.5a1 1 0 0 0-1 1V15a.5.5 0 1 1-1 0v-2.5c0-1.103.897-2 2-2h2.414a.249.249 0 0 0 .243-.189l.858-3.433a.5.5 0 1 1 .97.243l-.858 3.432a1.23 1.23 0 0 1-.615.776ZM6.5 12.5V15a.5.5 0 1 1-1 0v-2.5a1 1 0 0 0-1-1H2.476l-.906 3.62a.5.5 0 1 1-.97-.241l.888-3.55a1.23 1.23 0 0 1-.614-.776L.015 7.121a.5.5 0 1 1 .97-.242l.858 3.432a.249.249 0 0 0 .243.189H4.5c1.103 0 2 .897 2 2Zm6.5-6c0 .551-.45 1-1 1h-1.088C10.544 6.592 9.614 5.644 8 5.644c-1.615 0-2.544.948-2.911 1.856H4c-.552 0-1-.449-1-1v-4c0-.551.448-1 1-1h8c.55 0 1 .449 1 1v4ZM9.238 3.787a1.238 1.238 0 1 1-2.477 0 1.238 1.238 0 0 1 2.477 0Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_ZoomRoomChair_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = ZoomRoomChair;
exports["default"] = _default;